import { find, propEq } from 'ramda';
import { getCookie } from 'js/utils/cookie.util';
import { GUEST_ID_COOKIE_NAME, GUEST_ID_KEY } from './constants';

export const isConfiguredGuestIdCookie = find(propEq('name', GUEST_ID_COOKIE_NAME));

export const isAcceptedGuestIdCookie = () => {
    try {
        return JSON.parse(getCookie(GUEST_ID_COOKIE_NAME));
    } catch (e) {
        return false;
    }
};

export const getUserSelectedPaths = (state) => {
    let toSessionStorage = false;
    let toLocalStorage = false;
    const { app: { pgg2 = {}, cookiesConfiguration = {} } = {} } = state;
    const { guestsTracking = false } = pgg2;
    const { enablePresistentCookieLayer = false, consentCookies = [] } = cookiesConfiguration;
    const guestIdCookieConfig = isConfiguredGuestIdCookie(consentCookies);

    if (
        !guestsTracking
        || enablePresistentCookieLayer
            && guestIdCookieConfig
            && !isAcceptedGuestIdCookie()
    ) {
        toSessionStorage = true;
    } else {
        toLocalStorage = true;
    }

    return {
        toSessionStorage,
        toLocalStorage
    };
};

export const saveGuestIdToStorage = ({ app, user: { guestId } }) => {
    const { toSessionStorage, toLocalStorage } = getUserSelectedPaths({ app });

    if (guestId) {
        if (toLocalStorage) {
            localStorage.setItem(GUEST_ID_KEY, guestId);
            sessionStorage.removeItem(GUEST_ID_KEY);
        }

        if (toSessionStorage) {
            sessionStorage.setItem(GUEST_ID_KEY, guestId);
            localStorage.removeItem(GUEST_ID_KEY);
        }
    }
};

export const loadGuestIdFromStorage = () => {
    const lsGuestId = localStorage.getItem(GUEST_ID_KEY);
    const ssGuestId = sessionStorage.getItem(GUEST_ID_KEY);

    return {
        ...lsGuestId && { guestId: lsGuestId },
        ...ssGuestId && { guestId: ssGuestId }
    };
};

export const parseUserDetails = (data) => {
    const userDetails = { ...data };

    const ageDiffMs = Date.now() - new Date(userDetails.birthDate).getTime();
    const ageDate = new Date(ageDiffMs);

    userDetails.age = Math.abs(ageDate.getUTCFullYear() - 1970);

    return userDetails;
};
